import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=94d60252"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=94d60252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports